/************************************************************************
 ** IBM Confidential
 **
 ** IBM Business Analytics: Rapidly Adaptive Visualization Engine
 **
 ** (C) Copyright IBM Corp. 2024
 **
 ** The source code for this program is not published or otherwise divested of its trade secrets, 
 ** irrespective of what has been deposited with the U.S. Copyright Office.
 ************************************************************************/
// GENERATED
import ObjectType from './ObjectType';
import MoserObjectUtils from './MoserObjectUtils';
import MoserObject from './MoserObject';
import QsClassifierType from './QsClassifierType';
import InstanceType from './InstanceType';
import GenerateSQL from './GenerateSQL';
import QuerySubjectUsage from './QuerySubjectUsage';
import SelectListControlType from './SelectListControlType';
import SourceCategoryType from './SourceCategoryType';
import TreatAs from './TreatAs';
import SetOperation from './SetOperation';
import SetOperationDuplicates from './SetOperationDuplicates';
import PerspectiveType from './PerspectiveType';
//@import com/ibm/bi/platform/moser/common/generated/metadata/ObjectType (loadtime) // superclass
//@import com/ibm/bi/platform/moser/common/utils/MoserObjectUtils (runtime) // updateShortcutQSPropSet
//@import com/ibm/bi/platform/moser/common/generated/metadata/MoserObject (loadtime) // superclass, fromJSONHelper, updatePropertyOverride
//@import com/ibm/bi/platform/moser/common/generated/metadata/QsClassifierType (runtime) // new
//@import com/ibm/bi/platform/moser/common/generated/metadata/InstanceType (runtime) // new
//@import com/ibm/bi/platform/moser/common/generated/metadata/GenerateSQL (runtime) // new
//@import com/ibm/bi/platform/moser/common/generated/metadata/QuerySubjectUsage (runtime) // new
//@import com/ibm/bi/platform/moser/common/generated/metadata/SelectListControlType (runtime) // new
//@import com/ibm/bi/platform/moser/common/generated/metadata/SourceCategoryType (runtime) // new
//@import com/ibm/bi/platform/moser/common/generated/metadata/TreatAs (runtime) // new
//@import com/ibm/bi/platform/moser/common/generated/metadata/SetOperation (runtime) // new
//@import com/ibm/bi/platform/moser/common/generated/metadata/SetOperationDuplicates (runtime) // new
//@import com/ibm/bi/platform/moser/common/generated/metadata/PerspectiveType (runtime) // new

/**
 * <p>Java class for anonymous complex type. <p>The following schema fragment specifies the expected content contained within this class. <pre> &lt;complexType&gt; &lt;complexContent&gt; &lt;extension base="{}objectType"&gt; &lt;sequence&gt; &lt;sequence minOccurs="0"&gt; &lt;element name="ref" type="{http://www.w3.org/2001/XMLSchema}string" maxOccurs="unbounded" minOccurs="0"/&gt; &lt;element name="originalRef" type="{http://www.w3.org/2001/XMLSchema}string" maxOccurs="unbounded" minOccurs="0"/&gt; &lt;element name="classifier" type="{}qsClassifierType" minOccurs="0"/&gt; &lt;element name="instanceType" type="{}instanceType" minOccurs="0"/&gt; &lt;element ref="{}filter" maxOccurs="unbounded" minOccurs="0"/&gt; &lt;element name="item" type="{}itemType" maxOccurs="unbounded" minOccurs="0"/&gt; &lt;element name="itemNormalization" type="{}itemNormalizationType" minOccurs="0"/&gt; &lt;element name="shortcutTargetQuerySubjectRef" type="{http://www.w3.org/2001/XMLSchema}string" minOccurs="0"/&gt; &lt;element ref="{}securityFilter" maxOccurs="unbounded" minOccurs="0"/&gt; &lt;/sequence&gt; &lt;sequence minOccurs="0"&gt; &lt;element name="generateSQL" type="{}generateSQL" minOccurs="0"/&gt; &lt;element name="useInJoinPath" type="{http://www.w3.org/2001/XMLSchema}boolean" minOccurs="0"/&gt; &lt;element name="numberOfRows" type="{http://www.w3.org/2001/XMLSchema}string" minOccurs="0"/&gt; &lt;element name="rowCount" type="{http://www.w3.org/2001/XMLSchema}long" minOccurs="0"/&gt; &lt;element name="querySubjectUsage" type="{}querySubjectUsage" minOccurs="0"/&gt; &lt;element name="useLocalCache" type="{http://www.w3.org/2001/XMLSchema}boolean" minOccurs="0"/&gt; &lt;element name="selectListControl" type="{}selectListControlType" minOccurs="0"/&gt; &lt;choice&gt; &lt;element name="sqlQuery" type="{}sqlQueryType" minOccurs="0"/&gt; &lt;element name="queryOperation" minOccurs="0"&gt; &lt;complexType&gt; &lt;complexContent&gt; &lt;restriction base="{http://www.w3.org/2001/XMLSchema}anyType"&gt; &lt;sequence&gt; &lt;element name="queryRef" type="{http://www.w3.org/2001/XMLSchema}string" maxOccurs="unbounded"/&gt; &lt;element name="setOperation" type="{}setOperation"/&gt; &lt;element name="duplicates" type="{}setOperationDuplicates"/&gt; &lt;/sequence&gt; &lt;/restriction&gt; &lt;/complexContent&gt; &lt;/complexType&gt; &lt;/element&gt; &lt;element name="joinOperation" minOccurs="0"&gt; &lt;complexType&gt; &lt;complexContent&gt; &lt;restriction base="{http://www.w3.org/2001/XMLSchema}anyType"&gt; &lt;sequence&gt; &lt;element name="queryRef" type="{http://www.w3.org/2001/XMLSchema}string" maxOccurs="unbounded"/&gt; &lt;element ref="{}relationship" maxOccurs="unbounded" minOccurs="0"/&gt; &lt;/sequence&gt; &lt;/restriction&gt; &lt;/complexContent&gt; &lt;/complexType&gt; &lt;/element&gt; &lt;/choice&gt; &lt;element name="sourceCategory" type="{}sourceCategoryType" minOccurs="0"/&gt; &lt;element name="sortList" type="{}sortListType" minOccurs="0"/&gt; &lt;element name="dataCacheExpiry" type="{http://www.w3.org/2001/XMLSchema}string" minOccurs="0"/&gt; &lt;element name="treatAs" type="{}treatAs" minOccurs="0"/&gt; &lt;/sequence&gt; &lt;sequence minOccurs="0"&gt; &lt;element name="timeRef" type="{http://www.w3.org/2001/XMLSchema}string" maxOccurs="unbounded" minOccurs="0"/&gt; &lt;element name="timeGrain" maxOccurs="unbounded" minOccurs="0"&gt; &lt;complexType&gt; &lt;complexContent&gt; &lt;restriction base="{http://www.w3.org/2001/XMLSchema}anyType"&gt; &lt;sequence&gt; &lt;element name="periodName" type="{http://www.w3.org/2001/XMLSchema}string" minOccurs="0"/&gt; &lt;element name="numPeriods" type="{http://www.w3.org/2001/XMLSchema}string" maxOccurs="unbounded"/&gt; &lt;/sequence&gt; &lt;/restriction&gt; &lt;/complexContent&gt; &lt;/complexType&gt; &lt;/element&gt; &lt;element name="timeAnchor" minOccurs="0"&gt; &lt;complexType&gt; &lt;complexContent&gt; &lt;restriction base="{http://www.w3.org/2001/XMLSchema}anyType"&gt; &lt;sequence&gt; &lt;element name="perspective" type="{}perspectiveType" minOccurs="0"/&gt; &lt;element name="theDate" type="{http://www.w3.org/2001/XMLSchema}string" minOccurs="0"/&gt; &lt;/sequence&gt; &lt;/restriction&gt; &lt;/complexContent&gt; &lt;/complexType&gt; &lt;/element&gt; &lt;/sequence&gt; &lt;sequence minOccurs="0"&gt; &lt;element name="metricDefinitionRef" type="{http://www.w3.org/2001/XMLSchema}string" minOccurs="0"/&gt; &lt;element name="visualization" type="{http://www.w3.org/2001/XMLSchema}string" minOccurs="0"/&gt; &lt;element name="activeTimeGrain" minOccurs="0"&gt; &lt;complexType&gt; &lt;complexContent&gt; &lt;restriction base="{http://www.w3.org/2001/XMLSchema}anyType"&gt; &lt;sequence&gt; &lt;element name="periodName" type="{http://www.w3.org/2001/XMLSchema}string" minOccurs="0"/&gt; &lt;element name="numPeriods" type="{http://www.w3.org/2001/XMLSchema}string" maxOccurs="unbounded"/&gt; &lt;/sequence&gt; &lt;/restriction&gt; &lt;/complexContent&gt; &lt;/complexType&gt; &lt;/element&gt; &lt;element name="activeTimeRef" type="{http://www.w3.org/2001/XMLSchema}string" minOccurs="0"/&gt; &lt;/sequence&gt; &lt;sequence minOccurs="0"&gt; &lt;element name="columnDependency" maxOccurs="unbounded" minOccurs="0"&gt; &lt;complexType&gt; &lt;complexContent&gt; &lt;restriction base="{http://www.w3.org/2001/XMLSchema}anyType"&gt; &lt;sequence&gt; &lt;element name="ref" type="{http://www.w3.org/2001/XMLSchema}string"/&gt; &lt;element name="keyRef" type="{http://www.w3.org/2001/XMLSchema}string" maxOccurs="unbounded"/&gt; &lt;/sequence&gt; &lt;/restriction&gt; &lt;/complexContent&gt; &lt;/complexType&gt; &lt;/element&gt; &lt;element ref="{}queryItem" maxOccurs="unbounded" minOccurs="0"/&gt; &lt;/sequence&gt; &lt;/sequence&gt; &lt;/extension&gt; &lt;/complexContent&gt; &lt;/complexType&gt; </pre>
 */
export default class QuerySubject extends ObjectType{

	ref = null;

	originalRef = null;

	classifier = null;

	instanceType = null;

	filter = null;

	item = null;

	itemNormalization = null;

	shortcutTargetQuerySubjectRef = null;

	securityFilter = null;

	generateSQL = null;

	useInJoinPath = null;

	numberOfRows = null;

	rowCount = null;

	querySubjectUsage = null;

	useLocalCache = null;

	selectListControl = null;

	sqlQuery = null;

	queryOperation = null;

	joinOperation = null;

	sourceCategory = null;

	sortList = null;

	dataCacheExpiry = null;

	treatAs = null;

	timeRef = null;

	timeGrain = null;

	timeAnchor = null;

	metricDefinitionRef = null;

	visualization = null;

	activeTimeGrain = null;

	activeTimeRef = null;

	columnDependency = null;

	queryItem = null;



	/**
	 * Gets the value of the ref property. <p> This accessor method returns a reference to the live list, not a snapshot. Therefore any modification you make to the returned list will be present inside the JAXB object. This is why there is not a <CODE>set</CODE> method for the ref property. <p> For example, to add a new item, do as follows: <pre> getRef().add(newItem); </pre> <p> Objects of the following type(s) are allowed in the list {@link String}
	 */
	getRef() {
		if (!this.ref) {
			this.ref = [];
		}
		return this.ref;
	}

	/**
	 * Gets the value of the originalRef property. <p> This accessor method returns a reference to the live list, not a snapshot. Therefore any modification you make to the returned list will be present inside the JAXB object. This is why there is not a <CODE>set</CODE> method for the originalRef property. <p> For example, to add a new item, do as follows: <pre> getOriginalRef().add(newItem); </pre> <p> Objects of the following type(s) are allowed in the list {@link String}
	 */
	getOriginalRef() {
		if (!this.originalRef) {
			this.originalRef = [];
		}
		return this.originalRef;
	}

	/**
	 * Gets the value of the classifier property.
	 * @return {QsClassifierType} possible object is {@link QsClassifierType}
	 */
	getClassifier() {
		return this.classifier;
	}

	/**
	 * Sets the value of the classifier property.
	 * @param {QsClassifierType} value allowed object is {@link QsClassifierType}
	 */
	setClassifier(value) {
		var oldValue = this.classifier;
		this.classifier = value;
		this._setAndNotify(8, oldValue, value, false, true);
		MoserObjectUtils.updateShortcutQSPropSet(this, 8, value);
	}

	/**
	 * Gets the value of the instanceType property.
	 * @return {InstanceType} possible object is {@link InstanceType}
	 */
	getInstanceType() {
		return this.instanceType;
	}

	/**
	 * Sets the value of the instanceType property.
	 * @param {InstanceType} value allowed object is {@link InstanceType}
	 */
	setInstanceType(value) {
		var oldValue = this.instanceType;
		this.instanceType = value;
		this._setAndNotify(9, oldValue, value, false, true);
	}

	/**
	 * Gets the value of the filter property. <p> This accessor method returns a reference to the live list, not a snapshot. Therefore any modification you make to the returned list will be present inside the JAXB object. This is why there is not a <CODE>set</CODE> method for the filter property. <p> For example, to add a new item, do as follows: <pre> getFilter().add(newItem); </pre> <p> Objects of the following type(s) are allowed in the list {@link Filter}
	 */
	getFilter() {
		if (!this.filter) {
			this.filter = [];
		}
		return this.filter;
	}

	/**
	 * Gets the value of the item property. <p> This accessor method returns a reference to the live list, not a snapshot. Therefore any modification you make to the returned list will be present inside the JAXB object. This is why there is not a <CODE>set</CODE> method for the item property. <p> For example, to add a new item, do as follows: <pre> getItem().add(newItem); </pre> <p> Objects of the following type(s) are allowed in the list {@link ItemType}
	 */
	getItem() {
		if (!this.item) {
			this.item = [];
		}
		return this.item;
	}

	/**
	 * Gets the value of the itemNormalization property.
	 * @return {ItemNormalizationType} possible object is {@link ItemNormalizationType}
	 */
	getItemNormalization() {
		return this.itemNormalization;
	}

	/**
	 * Sets the value of the itemNormalization property.
	 * @param {ItemNormalizationType} value allowed object is {@link ItemNormalizationType}
	 */
	setItemNormalization(value) {
		var oldValue = this.itemNormalization;
		this.itemNormalization = value;
		this._setAndNotify(12, oldValue, value, true, true);
		MoserObjectUtils.updateShortcutQSPropSet(this, 12, value);
	}

	/**
	 * Gets the value of the shortcutTargetQuerySubjectRef property.
	 * @return {String} possible object is {@link String}
	 */
	getShortcutTargetQuerySubjectRef() {
		return this.shortcutTargetQuerySubjectRef;
	}

	/**
	 * Sets the value of the shortcutTargetQuerySubjectRef property.
	 * @param {String} value allowed object is {@link String}
	 */
	setShortcutTargetQuerySubjectRef(value) {
		var oldValue = this.shortcutTargetQuerySubjectRef;
		this.shortcutTargetQuerySubjectRef = value;
		this._setAndNotify(13, oldValue, value, false, true);
		MoserObjectUtils.updateShortcutQSPropSet(this, 13, value);
	}

	/**
	 * Gets the value of the securityFilter property. <p> This accessor method returns a reference to the live list, not a snapshot. Therefore any modification you make to the returned list will be present inside the JAXB object. This is why there is not a <CODE>set</CODE> method for the securityFilter property. <p> For example, to add a new item, do as follows: <pre> getSecurityFilter().add(newItem); </pre> <p> Objects of the following type(s) are allowed in the list {@link SecurityFilter}
	 */
	getSecurityFilter() {
		if (!this.securityFilter) {
			this.securityFilter = [];
		}
		return this.securityFilter;
	}

	/**
	 * Gets the value of the generateSQL property.
	 * @return {GenerateSQL} possible object is {@link GenerateSQL}
	 */
	getGenerateSQL() {
		return this.generateSQL;
	}

	/**
	 * Sets the value of the generateSQL property.
	 * @param {GenerateSQL} value allowed object is {@link GenerateSQL}
	 */
	setGenerateSQL(value) {
		var oldValue = this.generateSQL;
		this.generateSQL = value;
		this._setAndNotify(15, oldValue, value, false, true);
		MoserObjectUtils.updateShortcutQSPropSet(this, 15, value);
	}

	/**
	 * Gets the value of the useInJoinPath property.
	 * @return {Boolean} possible object is {@link Boolean}
	 */
	isUseInJoinPath() {
		return this.useInJoinPath;
	}

	/**
	 * Sets the value of the useInJoinPath property.
	 * @param {Boolean} value allowed object is {@link Boolean}
	 */
	setUseInJoinPath(value) {
		var oldValue = this.useInJoinPath;
		this.useInJoinPath = value;
		this._setAndNotify(16, oldValue, value, false, true);
		MoserObjectUtils.updateShortcutQSPropSet(this, 16, value);
	}

	/**
	 * Gets the value of the numberOfRows property.
	 * @return {String} possible object is {@link String}
	 */
	getNumberOfRows() {
		return this.numberOfRows;
	}

	/**
	 * Sets the value of the numberOfRows property.
	 * @param {String} value allowed object is {@link String}
	 */
	setNumberOfRows(value) {
		var oldValue = this.numberOfRows;
		this.numberOfRows = value;
		this._setAndNotify(17, oldValue, value, false, true);
		MoserObjectUtils.updateShortcutQSPropSet(this, 17, value);
	}

	/**
	 * Gets the value of the rowCount property.
	 * @return {Number} possible object is {@link Long}
	 */
	getRowCount() {
		return this.rowCount;
	}

	/**
	 * Sets the value of the rowCount property.
	 * @param {Number} value allowed object is {@link Long}
	 */
	setRowCount(value) {
		var oldValue = this.rowCount;
		this.rowCount = value;
		this._setAndNotify(18, oldValue, value, false, true);
		MoserObjectUtils.updateShortcutQSPropSet(this, 18, value);
	}

	/**
	 * Gets the value of the querySubjectUsage property.
	 * @return {QuerySubjectUsage} possible object is {@link QuerySubjectUsage}
	 */
	getQuerySubjectUsage() {
		return this.querySubjectUsage;
	}

	/**
	 * Sets the value of the querySubjectUsage property.
	 * @param {QuerySubjectUsage} value allowed object is {@link QuerySubjectUsage}
	 */
	setQuerySubjectUsage(value) {
		var oldValue = this.querySubjectUsage;
		this.querySubjectUsage = value;
		this._setAndNotify(19, oldValue, value, false, true);
		MoserObjectUtils.updateShortcutQSPropSet(this, 19, value);
	}

	/**
	 * Gets the value of the useLocalCache property.
	 * @return {Boolean} possible object is {@link Boolean}
	 */
	isUseLocalCache() {
		return this.useLocalCache;
	}

	/**
	 * Sets the value of the useLocalCache property.
	 * @param {Boolean} value allowed object is {@link Boolean}
	 */
	setUseLocalCache(value) {
		var oldValue = this.useLocalCache;
		this.useLocalCache = value;
		this._setAndNotify(20, oldValue, value, false, true);
		MoserObjectUtils.updateShortcutQSPropSet(this, 20, value);
	}

	/**
	 * Gets the value of the selectListControl property.
	 * @return {SelectListControlType} possible object is {@link SelectListControlType}
	 */
	getSelectListControl() {
		return this.selectListControl;
	}

	/**
	 * Sets the value of the selectListControl property.
	 * @param {SelectListControlType} value allowed object is {@link SelectListControlType}
	 */
	setSelectListControl(value) {
		var oldValue = this.selectListControl;
		this.selectListControl = value;
		this._setAndNotify(21, oldValue, value, false, true);
		MoserObjectUtils.updateShortcutQSPropSet(this, 21, value);
	}

	/**
	 * Gets the value of the sqlQuery property.
	 * @return {SqlQueryType} possible object is {@link SqlQueryType}
	 */
	getSqlQuery() {
		return this.sqlQuery;
	}

	/**
	 * Sets the value of the sqlQuery property.
	 * @param {SqlQueryType} value allowed object is {@link SqlQueryType}
	 */
	setSqlQuery(value) {
		var oldValue = this.sqlQuery;
		this.sqlQuery = value;
		this._setAndNotify(22, oldValue, value, true, true);
		MoserObjectUtils.updateShortcutQSPropSet(this, 22, value);
	}

	/**
	 * Gets the value of the queryOperation property.
	 * @return {QueryOperation} possible object is {@link QuerySubject.QueryOperation}
	 */
	getQueryOperation() {
		return this.queryOperation;
	}

	/**
	 * Sets the value of the queryOperation property.
	 * @param {QueryOperation} value allowed object is {@link QuerySubject.QueryOperation}
	 */
	setQueryOperation(value) {
		var oldValue = this.queryOperation;
		this.queryOperation = value;
		this._setAndNotify(23, oldValue, value, true, true);
		MoserObjectUtils.updateShortcutQSPropSet(this, 23, value);
	}

	/**
	 * Gets the value of the joinOperation property.
	 * @return {JoinOperation} possible object is {@link QuerySubject.JoinOperation}
	 */
	getJoinOperation() {
		return this.joinOperation;
	}

	/**
	 * Sets the value of the joinOperation property.
	 * @param {JoinOperation} value allowed object is {@link QuerySubject.JoinOperation}
	 */
	setJoinOperation(value) {
		var oldValue = this.joinOperation;
		this.joinOperation = value;
		this._setAndNotify(24, oldValue, value, true, true);
		MoserObjectUtils.updateShortcutQSPropSet(this, 24, value);
	}

	/**
	 * Gets the value of the sourceCategory property.
	 * @return {SourceCategoryType} possible object is {@link SourceCategoryType}
	 */
	getSourceCategory() {
		return this.sourceCategory;
	}

	/**
	 * Sets the value of the sourceCategory property.
	 * @param {SourceCategoryType} value allowed object is {@link SourceCategoryType}
	 */
	setSourceCategory(value) {
		var oldValue = this.sourceCategory;
		this.sourceCategory = value;
		this._setAndNotify(25, oldValue, value, false, true);
		MoserObjectUtils.updateShortcutQSPropSet(this, 25, value);
	}

	/**
	 * Gets the value of the sortList property.
	 * @return {SortListType} possible object is {@link SortListType}
	 */
	getSortList() {
		return this.sortList;
	}

	/**
	 * Sets the value of the sortList property.
	 * @param {SortListType} value allowed object is {@link SortListType}
	 */
	setSortList(value) {
		var oldValue = this.sortList;
		this.sortList = value;
		this._setAndNotify(26, oldValue, value, true, true);
		MoserObjectUtils.updateShortcutQSPropSet(this, 26, value);
	}

	/**
	 * Gets the value of the dataCacheExpiry property.
	 * @return {String} possible object is {@link String}
	 */
	getDataCacheExpiry() {
		return this.dataCacheExpiry;
	}

	/**
	 * Sets the value of the dataCacheExpiry property.
	 * @param {String} value allowed object is {@link String}
	 */
	setDataCacheExpiry(value) {
		var oldValue = this.dataCacheExpiry;
		this.dataCacheExpiry = value;
		this._setAndNotify(27, oldValue, value, false, true);
		MoserObjectUtils.updateShortcutQSPropSet(this, 27, value);
	}

	/**
	 * Gets the value of the treatAs property.
	 * @return {TreatAs} possible object is {@link TreatAs}
	 */
	getTreatAs() {
		return this.treatAs;
	}

	/**
	 * Sets the value of the treatAs property.
	 * @param {TreatAs} value allowed object is {@link TreatAs}
	 */
	setTreatAs(value) {
		var oldValue = this.treatAs;
		this.treatAs = value;
		this._setAndNotify(28, oldValue, value, false, true);
	}

	/**
	 * Gets the value of the timeRef property. <p> This accessor method returns a reference to the live list, not a snapshot. Therefore any modification you make to the returned list will be present inside the JAXB object. This is why there is not a <CODE>set</CODE> method for the timeRef property. <p> For example, to add a new item, do as follows: <pre> getTimeRef().add(newItem); </pre> <p> Objects of the following type(s) are allowed in the list {@link String}
	 */
	getTimeRef() {
		if (!this.timeRef) {
			this.timeRef = [];
		}
		return this.timeRef;
	}

	/**
	 * Gets the value of the timeGrain property. <p> This accessor method returns a reference to the live list, not a snapshot. Therefore any modification you make to the returned list will be present inside the JAXB object. This is why there is not a <CODE>set</CODE> method for the timeGrain property. <p> For example, to add a new item, do as follows: <pre> getTimeGrain().add(newItem); </pre> <p> Objects of the following type(s) are allowed in the list {@link QuerySubject.TimeGrain}
	 */
	getTimeGrain() {
		if (!this.timeGrain) {
			this.timeGrain = [];
		}
		return this.timeGrain;
	}

	/**
	 * Gets the value of the timeAnchor property.
	 * @return {TimeAnchor} possible object is {@link QuerySubject.TimeAnchor}
	 */
	getTimeAnchor() {
		return this.timeAnchor;
	}

	/**
	 * Sets the value of the timeAnchor property.
	 * @param {TimeAnchor} value allowed object is {@link QuerySubject.TimeAnchor}
	 */
	setTimeAnchor(value) {
		var oldValue = this.timeAnchor;
		this.timeAnchor = value;
		this._setAndNotify(31, oldValue, value, true, true);
	}

	/**
	 * Gets the value of the metricDefinitionRef property.
	 * @return {String} possible object is {@link String}
	 */
	getMetricDefinitionRef() {
		return this.metricDefinitionRef;
	}

	/**
	 * Sets the value of the metricDefinitionRef property.
	 * @param {String} value allowed object is {@link String}
	 */
	setMetricDefinitionRef(value) {
		var oldValue = this.metricDefinitionRef;
		this.metricDefinitionRef = value;
		this._setAndNotify(32, oldValue, value, false, true);
	}

	/**
	 * Gets the value of the visualization property.
	 * @return {String} possible object is {@link String}
	 */
	getVisualization() {
		return this.visualization;
	}

	/**
	 * Sets the value of the visualization property.
	 * @param {String} value allowed object is {@link String}
	 */
	setVisualization(value) {
		var oldValue = this.visualization;
		this.visualization = value;
		this._setAndNotify(33, oldValue, value, false, true);
	}

	/**
	 * Gets the value of the activeTimeGrain property.
	 * @return {ActiveTimeGrain} possible object is {@link QuerySubject.ActiveTimeGrain}
	 */
	getActiveTimeGrain() {
		return this.activeTimeGrain;
	}

	/**
	 * Sets the value of the activeTimeGrain property.
	 * @param {ActiveTimeGrain} value allowed object is {@link QuerySubject.ActiveTimeGrain}
	 */
	setActiveTimeGrain(value) {
		var oldValue = this.activeTimeGrain;
		this.activeTimeGrain = value;
		this._setAndNotify(34, oldValue, value, true, true);
	}

	/**
	 * Gets the value of the activeTimeRef property.
	 * @return {String} possible object is {@link String}
	 */
	getActiveTimeRef() {
		return this.activeTimeRef;
	}

	/**
	 * Sets the value of the activeTimeRef property.
	 * @param {String} value allowed object is {@link String}
	 */
	setActiveTimeRef(value) {
		var oldValue = this.activeTimeRef;
		this.activeTimeRef = value;
		this._setAndNotify(35, oldValue, value, false, true);
	}

	/**
	 * Gets the value of the columnDependency property. <p> This accessor method returns a reference to the live list, not a snapshot. Therefore any modification you make to the returned list will be present inside the JAXB object. This is why there is not a <CODE>set</CODE> method for the columnDependency property. <p> For example, to add a new item, do as follows: <pre> getColumnDependency().add(newItem); </pre> <p> Objects of the following type(s) are allowed in the list {@link QuerySubject.ColumnDependency}
	 */
	getColumnDependency() {
		if (!this.columnDependency) {
			this.columnDependency = [];
		}
		return this.columnDependency;
	}

	/**
	 * A query item from a query subject. Obsolete location (after 3.2). The new location is querySubject/item[n]/queryItem Gets the value of the queryItem property. <p> This accessor method returns a reference to the live list, not a snapshot. Therefore any modification you make to the returned list will be present inside the JAXB object. This is why there is not a <CODE>set</CODE> method for the queryItem property. <p> For example, to add a new item, do as follows: <pre> getQueryItem().add(newItem); </pre> <p> Objects of the following type(s) are allowed in the list {@link QueryItem}
	 */
	getQueryItem() {
		if (!this.queryItem) {
			this.queryItem = [];
		}
		return this.queryItem;
	}

	/**
	 * Gets the value of the <code>ref</code> property without initializing the property to an empty list if it is unset.
	 * @return {Array} the list of <code>String</code> elements, or <code>null</code> if not set
	 */
	basicGetRef() {
		return this.ref;
	}

	/**
	 * Gets the value of the <code>originalRef</code> property without initializing the property to an empty list if it is unset.
	 * @return {Array} the list of <code>String</code> elements, or <code>null</code> if not set
	 */
	basicGetOriginalRef() {
		return this.originalRef;
	}

	/**
	 * Gets the value of the <code>filter</code> property without initializing the property to an empty list if it is unset.
	 * @return {Array} the list of <code>Filter</code> elements, or <code>null</code> if not set
	 */
	basicGetFilter() {
		return this.filter;
	}

	/**
	 * Gets the value of the <code>item</code> property without initializing the property to an empty list if it is unset.
	 * @return {Array} the list of <code>ItemType</code> elements, or <code>null</code> if not set
	 */
	basicGetItem() {
		return this.item;
	}

	/**
	 * Gets the value of the <code>securityFilter</code> property without initializing the property to an empty list if it is unset.
	 * @return {Array} the list of <code>SecurityFilter</code> elements, or <code>null</code> if not set
	 */
	basicGetSecurityFilter() {
		return this.securityFilter;
	}

	/**
	 * Gets the value of the <code>timeRef</code> property without initializing the property to an empty list if it is unset.
	 * @return {Array} the list of <code>String</code> elements, or <code>null</code> if not set
	 */
	basicGetTimeRef() {
		return this.timeRef;
	}

	/**
	 * Gets the value of the <code>timeGrain</code> property without initializing the property to an empty list if it is unset.
	 * @return {Array} the list of <code>TimeGrain</code> elements, or <code>null</code> if not set
	 */
	basicGetTimeGrain() {
		return this.timeGrain;
	}

	/**
	 * Gets the value of the <code>columnDependency</code> property without initializing the property to an empty list if it is unset.
	 * @return {Array} the list of <code>ColumnDependency</code> elements, or <code>null</code> if not set
	 */
	basicGetColumnDependency() {
		return this.columnDependency;
	}

	/**
	 * Gets the value of the <code>queryItem</code> property without initializing the property to an empty list if it is unset.
	 * @return {Array} the list of <code>QueryItem</code> elements, or <code>null</code> if not set
	 */
	basicGetQueryItem() {
		return this.queryItem;
	}

	/**
	 * Creates a new instance of <code>QuerySubject</code> object from JSON data.
	 * @param {ObjectFactory} factory <code>ObjectFactory</> object for object creation.
	 * @param {Object} json JSON data to be used to create the <code> QuerySubject</code> object from.
	 * @return {QuerySubject} an object of type <code>QuerySubject</code>
	 */
	static fromJSON(json, factory) {
		var result = factory.createQuerySubject();
		var featureList = result.getFeatureList(factory);
		MoserObject.fromJSONHelper(result, featureList, json, factory);
		return result;
	}

	/**
	 * Adds the <code>item</code> to the collection at the given position and fires a notification to listeners.
	 */
	addRefAt(position, item) {
		this._addAtAndNotify(this.getRef(), position, item, 6, false, false);
	}

	/**
	 * Adds the <code>item</code> to the end of the collection and fires a notification to listeners.
	 */
	addRef(item) {
		this.addRefAt(this.getRef().length, item);
	}

	/**
	 * Removes the item at <code>position</code> from the collection and fires a notification to listeners.
	 */
	removeRefAt(position) {
		this._removeAtAndNotify(this.getRef(), position, 6, false);
	}

	/**
	 * Removes the <code>item</code> from the collection and fires a notification to listeners.
	 */
	removeRef(item) {
		var i = this.getRef().indexOf(item);
		if (i >= 0) {
			this.removeRefAt(i);
		}
	}

	/**
	 * Adds the <code>item</code> to the collection at the given position and fires a notification to listeners.
	 */
	addOriginalRefAt(position, item) {
		this._addAtAndNotify(this.getOriginalRef(), position, item, 7, false, false);
	}

	/**
	 * Adds the <code>item</code> to the end of the collection and fires a notification to listeners.
	 */
	addOriginalRef(item) {
		this.addOriginalRefAt(this.getOriginalRef().length, item);
	}

	/**
	 * Removes the item at <code>position</code> from the collection and fires a notification to listeners.
	 */
	removeOriginalRefAt(position) {
		this._removeAtAndNotify(this.getOriginalRef(), position, 7, false);
	}

	/**
	 * Removes the <code>item</code> from the collection and fires a notification to listeners.
	 */
	removeOriginalRef(item) {
		var i = this.getOriginalRef().indexOf(item);
		if (i >= 0) {
			this.removeOriginalRefAt(i);
		}
	}

	/**
	 * Adds the <code>item</code> to the collection at the given position and fires a notification to listeners.
	 */
	addFilterAt(position, item) {
		var filterList = this.getFilter();
		for (var i = 0; (i < filterList.length); ++i) {
			var override = filterList[i];
			if ((override.getIdentifier() != null) && override.getIdentifier() == item.getIdentifier()) {
				return;
			}
		}
		this._addAtAndNotify(this.getFilter(), position, item, 10, true, true);
	}

	/**
	 * Adds the <code>item</code> to the end of the collection and fires a notification to listeners.
	 */
	addFilter(item) {
		this.addFilterAt(this.getFilter().length, item);
	}

	/**
	 * Removes the item at <code>position</code> from the collection and fires a notification to listeners.
	 */
	removeFilterAt(position) {
		this._removeAtAndNotify(this.getFilter(), position, 10, true);
	}

	/**
	 * Removes the <code>item</code> from the collection and fires a notification to listeners.
	 */
	removeFilter(item) {
		var i = this.getFilter().indexOf(item);
		if (i >= 0) {
			this.removeFilterAt(i);
		}
	}

	/**
	 * Adds the <code>item</code> to the collection at the given position and fires a notification to listeners.
	 */
	addItemAt(position, item) {
		this._addAtAndNotify(this.getItem(), position, item, 11, true, false);
		var qi = item.getQueryItem();
		if (qi) {
			MoserObject.updatePropertyOverride(qi, this, 37, true);
		}
		var hierarchy = item.getItemHierarchy();
		if (hierarchy) {
			MoserObject.updatePropertyOverride(hierarchy, this, 102, true);
		}
		var namedSet = item.getNamedSet();
		if (namedSet) {
			MoserObject.updatePropertyOverride(namedSet, this, 68, true);
		}
		var filter = item.getFilter();
		if (filter) {
			MoserObject.updatePropertyOverride(filter, this, 10, true);
		}
		var folder = item.getFolder();
		if (folder) {
			MoserObject.updatePropertyOverride(folder, this, 101, true);
		}
	}

	/**
	 * Adds the <code>item</code> to the end of the collection and fires a notification to listeners.
	 */
	addItem(item) {
		this.addItemAt(this.getItem().length, item);
	}

	/**
	 * Removes the item at <code>position</code> from the collection and fires a notification to listeners.
	 */
	removeItemAt(position) {
		this._removeAtAndNotify(this.getItem(), position, 11, true);
	}

	/**
	 * Removes the <code>item</code> from the collection and fires a notification to listeners.
	 */
	removeItem(item) {
		var i = this.getItem().indexOf(item);
		if (i >= 0) {
			this.removeItemAt(i);
		}
	}

	/**
	 * Adds the <code>item</code> to the collection at the given position and fires a notification to listeners.
	 */
	addSecurityFilterAt(position, item) {
		this._addAtAndNotify(this.getSecurityFilter(), position, item, 14, true, true);
	}

	/**
	 * Adds the <code>item</code> to the end of the collection and fires a notification to listeners.
	 */
	addSecurityFilter(item) {
		this.addSecurityFilterAt(this.getSecurityFilter().length, item);
	}

	/**
	 * Removes the item at <code>position</code> from the collection and fires a notification to listeners.
	 */
	removeSecurityFilterAt(position) {
		this._removeAtAndNotify(this.getSecurityFilter(), position, 14, true);
	}

	/**
	 * Removes the <code>item</code> from the collection and fires a notification to listeners.
	 */
	removeSecurityFilter(item) {
		var i = this.getSecurityFilter().indexOf(item);
		if (i >= 0) {
			this.removeSecurityFilterAt(i);
		}
	}

	/**
	 * Adds the <code>item</code> to the collection at the given position and fires a notification to listeners.
	 */
	addTimeRefAt(position, item) {
		this._addAtAndNotify(this.getTimeRef(), position, item, 29, false, false);
	}

	/**
	 * Adds the <code>item</code> to the end of the collection and fires a notification to listeners.
	 */
	addTimeRef(item) {
		this.addTimeRefAt(this.getTimeRef().length, item);
	}

	/**
	 * Removes the item at <code>position</code> from the collection and fires a notification to listeners.
	 */
	removeTimeRefAt(position) {
		this._removeAtAndNotify(this.getTimeRef(), position, 29, false);
	}

	/**
	 * Removes the <code>item</code> from the collection and fires a notification to listeners.
	 */
	removeTimeRef(item) {
		var i = this.getTimeRef().indexOf(item);
		if (i >= 0) {
			this.removeTimeRefAt(i);
		}
	}

	/**
	 * Adds the <code>item</code> to the collection at the given position and fires a notification to listeners.
	 */
	addTimeGrainAt(position, item) {
		this._addAtAndNotify(this.getTimeGrain(), position, item, 30, true, false);
	}

	/**
	 * Adds the <code>item</code> to the end of the collection and fires a notification to listeners.
	 */
	addTimeGrain(item) {
		this.addTimeGrainAt(this.getTimeGrain().length, item);
	}

	/**
	 * Removes the item at <code>position</code> from the collection and fires a notification to listeners.
	 */
	removeTimeGrainAt(position) {
		this._removeAtAndNotify(this.getTimeGrain(), position, 30, true);
	}

	/**
	 * Removes the <code>item</code> from the collection and fires a notification to listeners.
	 */
	removeTimeGrain(item) {
		var i = this.getTimeGrain().indexOf(item);
		if (i >= 0) {
			this.removeTimeGrainAt(i);
		}
	}

	/**
	 * Adds the <code>item</code> to the collection at the given position and fires a notification to listeners.
	 */
	addColumnDependencyAt(position, item) {
		this._addAtAndNotify(this.getColumnDependency(), position, item, 36, true, false);
	}

	/**
	 * Adds the <code>item</code> to the end of the collection and fires a notification to listeners.
	 */
	addColumnDependency(item) {
		this.addColumnDependencyAt(this.getColumnDependency().length, item);
	}

	/**
	 * Removes the item at <code>position</code> from the collection and fires a notification to listeners.
	 */
	removeColumnDependencyAt(position) {
		this._removeAtAndNotify(this.getColumnDependency(), position, 36, true);
	}

	/**
	 * Removes the <code>item</code> from the collection and fires a notification to listeners.
	 */
	removeColumnDependency(item) {
		var i = this.getColumnDependency().indexOf(item);
		if (i >= 0) {
			this.removeColumnDependencyAt(i);
		}
	}

	/**
	 * Adds the <code>item</code> to the collection at the given position and fires a notification to listeners.
	 */
	addQueryItemAt(position, item) {
		this._addAtAndNotify(this.getQueryItem(), position, item, 37, true, true);
	}

	/**
	 * Adds the <code>item</code> to the end of the collection and fires a notification to listeners.
	 */
	addQueryItem(item) {
		this.addQueryItemAt(this.getQueryItem().length, item);
	}

	/**
	 * Removes the item at <code>position</code> from the collection and fires a notification to listeners.
	 */
	removeQueryItemAt(position) {
		this._removeAtAndNotify(this.getQueryItem(), position, 37, true);
	}

	/**
	 * Removes the <code>item</code> from the collection and fires a notification to listeners.
	 */
	removeQueryItem(item) {
		var i = this.getQueryItem().indexOf(item);
		if (i >= 0) {
			this.removeQueryItemAt(i);
		}
	}

	/**
	 * Retrieves the type of this object
	 * @return {String} the object type in a <code>String</code>
	 */
	getObjectType() {
		return "QuerySubject";
	}

	/**
	 * Get a list of FeatureObjects
	 * @return {Array} A list of FeatureObjects
	 */
	getFeatureList(factory) {
		var featureList = [];
		featureList.push(this.createFeature(true, false, false, 6, "ref", null));
		featureList.push(this.createFeature(true, false, false, 7, "originalRef", null));
		featureList.push(this.createFeature(false, true, false, 8, "classifier", QsClassifierType));
		featureList.push(this.createFeature(false, true, false, 9, "instanceType", InstanceType));
		var clazz;
		if (factory) {
			clazz = factory.createFilter().getClass();
		}
		featureList.push(this.createFeature(true, false, true, 10, "filter", clazz));
		if (factory) {
			clazz = factory.createItemType().getClass();
		}
		featureList.push(this.createFeature(true, false, true, 11, "item", clazz));
		if (factory) {
			clazz = factory.createItemNormalizationType().getClass();
		}
		featureList.push(this.createFeature(false, false, true, 12, "itemNormalization", clazz));
		featureList.push(this.createFeature(false, false, false, 13, "shortcutTargetQuerySubjectRef", null));
		if (factory) {
			clazz = factory.createSecurityFilter().getClass();
		}
		featureList.push(this.createFeature(true, false, true, 14, "securityFilter", clazz));
		featureList.push(this.createFeature(false, true, false, 15, "generateSQL", GenerateSQL));
		featureList.push(this.createFeature(false, false, false, 16, "useInJoinPath", null));
		featureList.push(this.createFeature(false, false, false, 17, "numberOfRows", null));
		featureList.push(this.createFeature(false, false, false, 18, "rowCount", null));
		featureList.push(this.createFeature(false, true, false, 19, "querySubjectUsage", QuerySubjectUsage));
		featureList.push(this.createFeature(false, false, false, 20, "useLocalCache", null));
		featureList.push(this.createFeature(false, true, false, 21, "selectListControl", SelectListControlType));
		if (factory) {
			clazz = factory.createSqlQueryType().getClass();
		}
		featureList.push(this.createFeature(false, false, true, 22, "sqlQuery", clazz));
		if (factory) {
			clazz = factory.createQuerySubjectQueryOperation().getClass();
		}
		featureList.push(this.createFeature(false, false, true, 23, "queryOperation", clazz));
		if (factory) {
			clazz = factory.createQuerySubjectJoinOperation().getClass();
		}
		featureList.push(this.createFeature(false, false, true, 24, "joinOperation", clazz));
		featureList.push(this.createFeature(false, true, false, 25, "sourceCategory", SourceCategoryType));
		if (factory) {
			clazz = factory.createSortListType().getClass();
		}
		featureList.push(this.createFeature(false, false, true, 26, "sortList", clazz));
		featureList.push(this.createFeature(false, false, false, 27, "dataCacheExpiry", null));
		featureList.push(this.createFeature(false, true, false, 28, "treatAs", TreatAs));
		featureList.push(this.createFeature(true, false, false, 29, "timeRef", null));
		if (factory) {
			clazz = factory.createQuerySubjectTimeGrain().getClass();
		}
		featureList.push(this.createFeature(true, false, true, 30, "timeGrain", clazz));
		if (factory) {
			clazz = factory.createQuerySubjectTimeAnchor().getClass();
		}
		featureList.push(this.createFeature(false, false, true, 31, "timeAnchor", clazz));
		featureList.push(this.createFeature(false, false, false, 32, "metricDefinitionRef", null));
		featureList.push(this.createFeature(false, false, false, 33, "visualization", null));
		if (factory) {
			clazz = factory.createQuerySubjectActiveTimeGrain().getClass();
		}
		featureList.push(this.createFeature(false, false, true, 34, "activeTimeGrain", clazz));
		featureList.push(this.createFeature(false, false, false, 35, "activeTimeRef", null));
		if (factory) {
			clazz = factory.createQuerySubjectColumnDependency().getClass();
		}
		featureList.push(this.createFeature(true, false, true, 36, "columnDependency", clazz));
		if (factory) {
			clazz = factory.createQueryItem().getClass();
		}
		featureList.push(this.createFeature(true, false, true, 37, "queryItem", clazz));
		Array.prototype.push.apply(featureList, super.getFeatureList(factory));
		return featureList;
	}

	/**
	 * Set the value of a specific feature.
	 * @param {BaseMoserObject} value the value to set
	 * @param {int} featureID the feature id of the attribute to be set
	 */
	set(featureID, value) {
		switch (featureID) {
		case 8:
			this.setClassifier((value));
			break;
		case 9:
			this.setInstanceType((value));
			break;
		case 12:
			this.setItemNormalization((value));
			break;
		case 13:
			this.setShortcutTargetQuerySubjectRef((value));
			break;
		case 15:
			this.setGenerateSQL((value));
			break;
		case 16:
			this.setUseInJoinPath((value));
			break;
		case 17:
			this.setNumberOfRows((value));
			break;
		case 18:
			this.setRowCount((value));
			break;
		case 19:
			this.setQuerySubjectUsage((value));
			break;
		case 20:
			this.setUseLocalCache((value));
			break;
		case 21:
			this.setSelectListControl((value));
			break;
		case 22:
			this.setSqlQuery((value));
			break;
		case 23:
			this.setQueryOperation((value));
			break;
		case 24:
			this.setJoinOperation((value));
			break;
		case 25:
			this.setSourceCategory((value));
			break;
		case 26:
			this.setSortList((value));
			break;
		case 27:
			this.setDataCacheExpiry((value));
			break;
		case 28:
			this.setTreatAs((value));
			break;
		case 31:
			this.setTimeAnchor((value));
			break;
		case 32:
			this.setMetricDefinitionRef((value));
			break;
		case 33:
			this.setVisualization((value));
			break;
		case 34:
			this.setActiveTimeGrain((value));
			break;
		case 35:
			this.setActiveTimeRef((value));
			break;
		default:
			super.set(featureID, value);
		}
	}

	/**
	 * Set the value of a specific feature.
	 * @param {BaseMoserObject} value the value to set the value to set
	 * @param {int} featureID the feature id of the attribute to be set the feature id of the attribute to be set
	 */
	_setList(featureID, value) {
		switch (featureID) {
		case 6:
			this.ref = (value);
			break;
		case 7:
			this.originalRef = (value);
			break;
		case 10:
			this.filter = (value);
			break;
		case 11:
			this.item = (value);
			break;
		case 14:
			this.securityFilter = (value);
			break;
		case 29:
			this.timeRef = (value);
			break;
		case 30:
			this.timeGrain = (value);
			break;
		case 36:
			this.columnDependency = (value);
			break;
		case 37:
			this.queryItem = (value);
			break;
		default:
			super._setList(featureID, value);
		}
	}

	/**
	 * Get the value of a specific feature.
	 * @param {int} featureID the feature id of the attribute to get
	 */
	get(featureID) {
		switch (featureID) {
		case 6:
			return this.getRef();
		case 7:
			return this.getOriginalRef();
		case 8:
			return this.getClassifier();
		case 9:
			return this.getInstanceType();
		case 10:
			return this.getFilter();
		case 11:
			return this.getItem();
		case 12:
			return this.getItemNormalization();
		case 13:
			return this.getShortcutTargetQuerySubjectRef();
		case 14:
			return this.getSecurityFilter();
		case 15:
			return this.getGenerateSQL();
		case 16:
			return this.isUseInJoinPath();
		case 17:
			return this.getNumberOfRows();
		case 18:
			return this.getRowCount();
		case 19:
			return this.getQuerySubjectUsage();
		case 20:
			return this.isUseLocalCache();
		case 21:
			return this.getSelectListControl();
		case 22:
			return this.getSqlQuery();
		case 23:
			return this.getQueryOperation();
		case 24:
			return this.getJoinOperation();
		case 25:
			return this.getSourceCategory();
		case 26:
			return this.getSortList();
		case 27:
			return this.getDataCacheExpiry();
		case 28:
			return this.getTreatAs();
		case 29:
			return this.getTimeRef();
		case 30:
			return this.getTimeGrain();
		case 31:
			return this.getTimeAnchor();
		case 32:
			return this.getMetricDefinitionRef();
		case 33:
			return this.getVisualization();
		case 34:
			return this.getActiveTimeGrain();
		case 35:
			return this.getActiveTimeRef();
		case 36:
			return this.getColumnDependency();
		case 37:
			return this.getQueryItem();
		default:
			return super.get(featureID);
		}
	}

	/**
	 * Get the value of a specific feature.
	 * @param {int} featureID the feature id of the attribute to get
	 */
	basicGet(featureID) {
		switch (featureID) {
		case 6:
			return this.basicGetRef();
		case 7:
			return this.basicGetOriginalRef();
		case 8:
			return this.getClassifier();
		case 9:
			return this.getInstanceType();
		case 10:
			return this.basicGetFilter();
		case 11:
			return this.basicGetItem();
		case 12:
			return this.getItemNormalization();
		case 13:
			return this.getShortcutTargetQuerySubjectRef();
		case 14:
			return this.basicGetSecurityFilter();
		case 15:
			return this.getGenerateSQL();
		case 16:
			return this.isUseInJoinPath();
		case 17:
			return this.getNumberOfRows();
		case 18:
			return this.getRowCount();
		case 19:
			return this.getQuerySubjectUsage();
		case 20:
			return this.isUseLocalCache();
		case 21:
			return this.getSelectListControl();
		case 22:
			return this.getSqlQuery();
		case 23:
			return this.getQueryOperation();
		case 24:
			return this.getJoinOperation();
		case 25:
			return this.getSourceCategory();
		case 26:
			return this.getSortList();
		case 27:
			return this.getDataCacheExpiry();
		case 28:
			return this.getTreatAs();
		case 29:
			return this.basicGetTimeRef();
		case 30:
			return this.basicGetTimeGrain();
		case 31:
			return this.getTimeAnchor();
		case 32:
			return this.getMetricDefinitionRef();
		case 33:
			return this.getVisualization();
		case 34:
			return this.getActiveTimeGrain();
		case 35:
			return this.getActiveTimeRef();
		case 36:
			return this.basicGetColumnDependency();
		case 37:
			return this.basicGetQueryItem();
		default:
			return super.basicGet(featureID);
		}
	}

	/**
	 * Add the value of a specific feature at a specific position
	 * @param {int} position the array position of the item to be added
	 * @param {BaseMoserObject} value the value to add
	 * @param {int} featureID the feature id of the attribute to be added
	 */
	addAt(featureID, position, value) {
		switch (featureID) {
		case 6:
			this.addRefAt(position, (value));
			break;
		case 7:
			this.addOriginalRefAt(position, (value));
			break;
		case 10:
			this.addFilterAt(position, (value));
			break;
		case 11:
			this.addItemAt(position, (value));
			break;
		case 14:
			this.addSecurityFilterAt(position, (value));
			break;
		case 29:
			this.addTimeRefAt(position, (value));
			break;
		case 30:
			this.addTimeGrainAt(position, (value));
			break;
		case 36:
			this.addColumnDependencyAt(position, (value));
			break;
		case 37:
			this.addQueryItemAt(position, (value));
			break;
		default:
			super.addAt(featureID, position, value);
		}
	}

	/**
	 * Add the value to the end of a specific collection feature
	 * @param {BaseMoserObject} value the value to add
	 * @param {int} featureID the feature id of the attribute to be added
	 */
	add(featureID, value) {
		switch (featureID) {
		case 6:
			this.addRef((value));
			break;
		case 7:
			this.addOriginalRef((value));
			break;
		case 10:
			this.addFilter((value));
			break;
		case 11:
			this.addItem((value));
			break;
		case 14:
			this.addSecurityFilter((value));
			break;
		case 29:
			this.addTimeRef((value));
			break;
		case 30:
			this.addTimeGrain((value));
			break;
		case 36:
			this.addColumnDependency((value));
			break;
		case 37:
			this.addQueryItem((value));
			break;
		default:
			super.add(featureID, value);
		}
	}

	/**
	 * Remove the value of a specific feature by index.
	 * @param {int} position the array position of the item to be removed
	 * @param {int} featureID the feature id of the attribute to be removed
	 */
	removeAt(featureID, position) {
		switch (featureID) {
		case 6:
			this.removeRefAt(position);
			break;
		case 7:
			this.removeOriginalRefAt(position);
			break;
		case 10:
			this.removeFilterAt(position);
			break;
		case 11:
			this.removeItemAt(position);
			break;
		case 14:
			this.removeSecurityFilterAt(position);
			break;
		case 29:
			this.removeTimeRefAt(position);
			break;
		case 30:
			this.removeTimeGrainAt(position);
			break;
		case 36:
			this.removeColumnDependencyAt(position);
			break;
		case 37:
			this.removeQueryItemAt(position);
			break;
		default:
			super.removeAt(featureID, position);
		}
	}

	/**
	 * Remove the value from specific feature.
	 * @param {BaseMoserObject} item the item to be removed
	 * @param {int} featureID the feature id of the attribute to be removed
	 */
	remove(featureID, item) {
		switch (featureID) {
		case 6:
			this.removeRef((item));
			break;
		case 7:
			this.removeOriginalRef((item));
			break;
		case 10:
			this.removeFilter((item));
			break;
		case 11:
			this.removeItem((item));
			break;
		case 14:
			this.removeSecurityFilter((item));
			break;
		case 29:
			this.removeTimeRef((item));
			break;
		case 30:
			this.removeTimeGrain((item));
			break;
		case 36:
			this.removeColumnDependency((item));
			break;
		case 37:
			this.removeQueryItem((item));
			break;
		default:
			super.remove(featureID, item);
		}
	}
}
/**
 * <p>Java class for anonymous complex type. <p>The following schema fragment specifies the expected content contained within this class. <pre> &lt;complexType&gt; &lt;complexContent&gt; &lt;restriction base="{http://www.w3.org/2001/XMLSchema}anyType"&gt; &lt;sequence&gt; &lt;element name="periodName" type="{http://www.w3.org/2001/XMLSchema}string" minOccurs="0"/&gt; &lt;element name="numPeriods" type="{http://www.w3.org/2001/XMLSchema}string" maxOccurs="unbounded"/&gt; &lt;/sequence&gt; &lt;/restriction&gt; &lt;/complexContent&gt; &lt;/complexType&gt; </pre>
 */
QuerySubject.ActiveTimeGrain = class extends MoserObject{

	periodName = null;

	numPeriods = null;



	/**
	 * Gets the value of the periodName property.
	 * @return {String} possible object is {@link String}
	 */
	getPeriodName() {
		return this.periodName;
	}

	/**
	 * Sets the value of the periodName property.
	 * @param {String} value allowed object is {@link String}
	 */
	setPeriodName(value) {
		var oldValue = this.periodName;
		this.periodName = value;
		this._setAndNotify(177, oldValue, value, false, false);
	}

	/**
	 * Gets the value of the numPeriods property. <p> This accessor method returns a reference to the live list, not a snapshot. Therefore any modification you make to the returned list will be present inside the JAXB object. This is why there is not a <CODE>set</CODE> method for the numPeriods property. <p> For example, to add a new item, do as follows: <pre> getNumPeriods().add(newItem); </pre> <p> Objects of the following type(s) are allowed in the list {@link String}
	 */
	getNumPeriods() {
		if (!this.numPeriods) {
			this.numPeriods = [];
		}
		return this.numPeriods;
	}

	/**
	 * Gets the value of the <code>numPeriods</code> property without initializing the property to an empty list if it is unset.
	 * @return {Array} the list of <code>String</code> elements, or <code>null</code> if not set
	 */
	basicGetNumPeriods() {
		return this.numPeriods;
	}

	/**
	 * Creates a new instance of <code>ActiveTimeGrain</code> object from JSON data.
	 * @param {ObjectFactory} factory <code>ObjectFactory</> object for object creation.
	 * @param {Object} json JSON data to be used to create the <code> ActiveTimeGrain</code> object from.
	 * @return {ActiveTimeGrain} an object of type <code>ActiveTimeGrain</code>
	 */
	static fromJSON(json, factory) {
		var result = factory.createQuerySubjectActiveTimeGrain();
		var featureList = result.getFeatureList(factory);
		MoserObject.fromJSONHelper(result, featureList, json, factory);
		return result;
	}

	/**
	 * Adds the <code>item</code> to the collection at the given position and fires a notification to listeners.
	 */
	addNumPeriodsAt(position, item) {
		this._addAtAndNotify(this.getNumPeriods(), position, item, 178, false, false);
	}

	/**
	 * Adds the <code>item</code> to the end of the collection and fires a notification to listeners.
	 */
	addNumPeriods(item) {
		this.addNumPeriodsAt(this.getNumPeriods().length, item);
	}

	/**
	 * Removes the item at <code>position</code> from the collection and fires a notification to listeners.
	 */
	removeNumPeriodsAt(position) {
		this._removeAtAndNotify(this.getNumPeriods(), position, 178, false);
	}

	/**
	 * Removes the <code>item</code> from the collection and fires a notification to listeners.
	 */
	removeNumPeriods(item) {
		var i = this.getNumPeriods().indexOf(item);
		if (i >= 0) {
			this.removeNumPeriodsAt(i);
		}
	}

	/**
	 * Retrieves the type of this object
	 * @return {String} the object type in a <code>String</code>
	 */
	getObjectType() {
		return "ActiveTimeGrain";
	}

	/**
	 * Get a list of FeatureObjects
	 * @return {Array} A list of FeatureObjects
	 */
	getFeatureList(factory) {
		var featureList = [];
		featureList.push(this.createFeature(false, false, false, 177, "periodName", null));
		featureList.push(this.createFeature(true, false, false, 178, "numPeriods", null));
		Array.prototype.push.apply(featureList, super.getFeatureList(factory));
		return featureList;
	}

	/**
	 * Set the value of a specific feature.
	 * @param {BaseMoserObject} value the value to set
	 * @param {int} featureID the feature id of the attribute to be set
	 */
	set(featureID, value) {
		switch (featureID) {
		case 177:
			this.setPeriodName((value));
			break;
		default:
			throw new Error((("The feature " + featureID) + " is not valid."));
		}
	}

	/**
	 * Set the value of a specific feature.
	 * @param {BaseMoserObject} value the value to set the value to set
	 * @param {int} featureID the feature id of the attribute to be set the feature id of the attribute to be set
	 */
	_setList(featureID, value) {
		switch (featureID) {
		case 178:
			this.numPeriods = (value);
			break;
		default:
			throw new Error((("The feature " + featureID) + " is not valid."));
		}
	}

	/**
	 * Get the value of a specific feature.
	 * @param {int} featureID the feature id of the attribute to get
	 */
	get(featureID) {
		switch (featureID) {
		case 177:
			return this.getPeriodName();
		case 178:
			return this.getNumPeriods();
		default:
			throw new Error((("The feature " + featureID) + " is not valid."));
		}
	}

	/**
	 * Get the value of a specific feature.
	 * @param {int} featureID the feature id of the attribute to get
	 */
	basicGet(featureID) {
		switch (featureID) {
		case 177:
			return this.getPeriodName();
		case 178:
			return this.basicGetNumPeriods();
		default:
			throw new Error((("The feature " + featureID) + " is not valid."));
		}
	}

	/**
	 * Add the value of a specific feature at a specific position
	 * @param {int} position the array position of the item to be added
	 * @param {BaseMoserObject} value the value to add
	 * @param {int} featureID the feature id of the attribute to be added
	 */
	addAt(featureID, position, value) {
		switch (featureID) {
		case 178:
			this.addNumPeriodsAt(position, (value));
			break;
		default:
			throw new Error((("The feature " + featureID) + " is not valid."));
		}
	}

	/**
	 * Add the value to the end of a specific collection feature
	 * @param {BaseMoserObject} value the value to add
	 * @param {int} featureID the feature id of the attribute to be added
	 */
	add(featureID, value) {
		switch (featureID) {
		case 178:
			this.addNumPeriods((value));
			break;
		default:
			throw new Error((("The feature " + featureID) + " is not valid."));
		}
	}

	/**
	 * Remove the value of a specific feature by index.
	 * @param {int} position the array position of the item to be removed
	 * @param {int} featureID the feature id of the attribute to be removed
	 */
	removeAt(featureID, position) {
		switch (featureID) {
		case 178:
			this.removeNumPeriodsAt(position);
			break;
		default:
			throw new Error((("The feature " + featureID) + " is not valid."));
		}
	}

	/**
	 * Remove the value from specific feature.
	 * @param {BaseMoserObject} item the item to be removed
	 * @param {int} featureID the feature id of the attribute to be removed
	 */
	remove(featureID, item) {
		switch (featureID) {
		case 178:
			this.removeNumPeriods((item));
			break;
		default:
			throw new Error((("The feature " + featureID) + " is not valid."));
		}
	}
}
/**
 * <p>Java class for anonymous complex type. <p>The following schema fragment specifies the expected content contained within this class. <pre> &lt;complexType&gt; &lt;complexContent&gt; &lt;restriction base="{http://www.w3.org/2001/XMLSchema}anyType"&gt; &lt;sequence&gt; &lt;element name="ref" type="{http://www.w3.org/2001/XMLSchema}string"/&gt; &lt;element name="keyRef" type="{http://www.w3.org/2001/XMLSchema}string" maxOccurs="unbounded"/&gt; &lt;/sequence&gt; &lt;/restriction&gt; &lt;/complexContent&gt; &lt;/complexType&gt; </pre>
 */
QuerySubject.ColumnDependency = class extends MoserObject{

	ref = null;

	keyRef = null;

	_referencedObject = null;



	/**
	 * Gets the value of the ref property.
	 * @return {String} possible object is {@link String}
	 */
	getRef() {
		return this.ref;
	}

	/**
	 * Sets the value of the ref property.
	 * @param {String} value allowed object is {@link String}
	 */
	setRef(value) {
		var oldValue = this.ref;
		this.ref = value;
		this._setAndNotify(6, oldValue, value, false, false);
		this._referencedObject = null;
	}

	/**
	 * Gets the value of the keyRef property. <p> This accessor method returns a reference to the live list, not a snapshot. Therefore any modification you make to the returned list will be present inside the JAXB object. This is why there is not a <CODE>set</CODE> method for the keyRef property. <p> For example, to add a new item, do as follows: <pre> getKeyRef().add(newItem); </pre> <p> Objects of the following type(s) are allowed in the list {@link String}
	 */
	getKeyRef() {
		if (!this.keyRef) {
			this.keyRef = [];
		}
		return this.keyRef;
	}

	/**
	 * Gets the value of the <code>keyRef</code> property without initializing the property to an empty list if it is unset.
	 * @return {Array} the list of <code>String</code> elements, or <code>null</code> if not set
	 */
	basicGetKeyRef() {
		return this.keyRef;
	}

	/**
	 * Creates a new instance of <code>ColumnDependency</code> object from JSON data.
	 * @param {ObjectFactory} factory <code>ObjectFactory</> object for object creation.
	 * @param {Object} json JSON data to be used to create the <code> ColumnDependency</code> object from.
	 * @return {ColumnDependency} an object of type <code>ColumnDependency</code>
	 */
	static fromJSON(json, factory) {
		var result = factory.createQuerySubjectColumnDependency();
		var featureList = result.getFeatureList(factory);
		MoserObject.fromJSONHelper(result, featureList, json, factory);
		return result;
	}

	/**
	 * Adds the <code>item</code> to the collection at the given position and fires a notification to listeners.
	 */
	addKeyRefAt(position, item) {
		this._addAtAndNotify(this.getKeyRef(), position, item, 181, false, false);
	}

	/**
	 * Adds the <code>item</code> to the end of the collection and fires a notification to listeners.
	 */
	addKeyRef(item) {
		this.addKeyRefAt(this.getKeyRef().length, item);
	}

	/**
	 * Removes the item at <code>position</code> from the collection and fires a notification to listeners.
	 */
	removeKeyRefAt(position) {
		this._removeAtAndNotify(this.getKeyRef(), position, 181, false);
	}

	/**
	 * Removes the <code>item</code> from the collection and fires a notification to listeners.
	 */
	removeKeyRef(item) {
		var i = this.getKeyRef().indexOf(item);
		if (i >= 0) {
			this.removeKeyRefAt(i);
		}
	}

	/**
	 * Retrieves the type of this object
	 * @return {String} the object type in a <code>String</code>
	 */
	getObjectType() {
		return "ColumnDependency";
	}

	/**
	 * Get a list of FeatureObjects
	 * @return {Array} A list of FeatureObjects
	 */
	getFeatureList(factory) {
		var featureList = [];
		featureList.push(this.createFeature(false, false, false, 6, "ref", null));
		featureList.push(this.createFeature(true, false, false, 181, "keyRef", null));
		Array.prototype.push.apply(featureList, super.getFeatureList(factory));
		return featureList;
	}

	/**
	 * Set the value of a specific feature.
	 * @param {BaseMoserObject} value the value to set
	 * @param {int} featureID the feature id of the attribute to be set
	 */
	set(featureID, value) {
		switch (featureID) {
		case 6:
			this.setRef((value));
			break;
		default:
			throw new Error((("The feature " + featureID) + " is not valid."));
		}
	}

	/**
	 * Set the value of a specific feature.
	 * @param {BaseMoserObject} value the value to set the value to set
	 * @param {int} featureID the feature id of the attribute to be set the feature id of the attribute to be set
	 */
	_setList(featureID, value) {
		switch (featureID) {
		case 181:
			this.keyRef = (value);
			break;
		default:
			throw new Error((("The feature " + featureID) + " is not valid."));
		}
	}

	/**
	 * Get the value of a specific feature.
	 * @param {int} featureID the feature id of the attribute to get
	 */
	get(featureID) {
		switch (featureID) {
		case 6:
			return this.getRef();
		case 181:
			return this.getKeyRef();
		default:
			throw new Error((("The feature " + featureID) + " is not valid."));
		}
	}

	/**
	 * Get the value of a specific feature.
	 * @param {int} featureID the feature id of the attribute to get
	 */
	basicGet(featureID) {
		switch (featureID) {
		case 6:
			return this.getRef();
		case 181:
			return this.basicGetKeyRef();
		default:
			throw new Error((("The feature " + featureID) + " is not valid."));
		}
	}

	/**
	 * Add the value of a specific feature at a specific position
	 * @param {int} position the array position of the item to be added
	 * @param {BaseMoserObject} value the value to add
	 * @param {int} featureID the feature id of the attribute to be added
	 */
	addAt(featureID, position, value) {
		switch (featureID) {
		case 181:
			this.addKeyRefAt(position, (value));
			break;
		default:
			throw new Error((("The feature " + featureID) + " is not valid."));
		}
	}

	/**
	 * Add the value to the end of a specific collection feature
	 * @param {BaseMoserObject} value the value to add
	 * @param {int} featureID the feature id of the attribute to be added
	 */
	add(featureID, value) {
		switch (featureID) {
		case 181:
			this.addKeyRef((value));
			break;
		default:
			throw new Error((("The feature " + featureID) + " is not valid."));
		}
	}

	/**
	 * Remove the value of a specific feature by index.
	 * @param {int} position the array position of the item to be removed
	 * @param {int} featureID the feature id of the attribute to be removed
	 */
	removeAt(featureID, position) {
		switch (featureID) {
		case 181:
			this.removeKeyRefAt(position);
			break;
		default:
			throw new Error((("The feature " + featureID) + " is not valid."));
		}
	}

	/**
	 * Remove the value from specific feature.
	 * @param {BaseMoserObject} item the item to be removed
	 * @param {int} featureID the feature id of the attribute to be removed
	 */
	remove(featureID, item) {
		switch (featureID) {
		case 181:
			this.removeKeyRef((item));
			break;
		default:
			throw new Error((("The feature " + featureID) + " is not valid."));
		}
	}

	/**
	 * Set the resolved object based on reference.
	 * @param {MoserObject} referencedObject the referenced <code>MoserObject</code>
	 */
	setReferencedObject(referencedObject) {
		this._referencedObject = referencedObject;
	}

	/**
	 * Get the resolved object based on reference.
	 * @return {MoserObject} the referenced <code>MoserObject</code>
	 */
	getReferencedObject() {
		return this._referencedObject;
	}

	clone() {
		var cloned = (super.clone());
		cloned.setReferencedObject(this._referencedObject);
		return cloned;
	}
}
/**
 * <p>Java class for anonymous complex type. <p>The following schema fragment specifies the expected content contained within this class. <pre> &lt;complexType&gt; &lt;complexContent&gt; &lt;restriction base="{http://www.w3.org/2001/XMLSchema}anyType"&gt; &lt;sequence&gt; &lt;element name="queryRef" type="{http://www.w3.org/2001/XMLSchema}string" maxOccurs="unbounded"/&gt; &lt;element ref="{}relationship" maxOccurs="unbounded" minOccurs="0"/&gt; &lt;/sequence&gt; &lt;/restriction&gt; &lt;/complexContent&gt; &lt;/complexType&gt; </pre>
 */
QuerySubject.JoinOperation = class extends MoserObject{

	queryRef = null;

	relationship = null;



	/**
	 * Gets the value of the queryRef property. <p> This accessor method returns a reference to the live list, not a snapshot. Therefore any modification you make to the returned list will be present inside the JAXB object. This is why there is not a <CODE>set</CODE> method for the queryRef property. <p> For example, to add a new item, do as follows: <pre> getQueryRef().add(newItem); </pre> <p> Objects of the following type(s) are allowed in the list {@link String}
	 */
	getQueryRef() {
		if (!this.queryRef) {
			this.queryRef = [];
		}
		return this.queryRef;
	}

	/**
	 * A query that represents the join of two query subjects or tables.Gets the value of the relationship property. <p> This accessor method returns a reference to the live list, not a snapshot. Therefore any modification you make to the returned list will be present inside the JAXB object. This is why there is not a <CODE>set</CODE> method for the relationship property. <p> For example, to add a new item, do as follows: <pre> getRelationship().add(newItem); </pre> <p> Objects of the following type(s) are allowed in the list {@link Relationship}
	 */
	getRelationship() {
		if (!this.relationship) {
			this.relationship = [];
		}
		return this.relationship;
	}

	/**
	 * Gets the value of the <code>queryRef</code> property without initializing the property to an empty list if it is unset.
	 * @return {Array} the list of <code>String</code> elements, or <code>null</code> if not set
	 */
	basicGetQueryRef() {
		return this.queryRef;
	}

	/**
	 * Gets the value of the <code>relationship</code> property without initializing the property to an empty list if it is unset.
	 * @return {Array} the list of <code>Relationship</code> elements, or <code>null</code> if not set
	 */
	basicGetRelationship() {
		return this.relationship;
	}

	/**
	 * Creates a new instance of <code>JoinOperation</code> object from JSON data.
	 * @param {ObjectFactory} factory <code>ObjectFactory</> object for object creation.
	 * @param {Object} json JSON data to be used to create the <code> JoinOperation</code> object from.
	 * @return {JoinOperation} an object of type <code>JoinOperation</code>
	 */
	static fromJSON(json, factory) {
		var result = factory.createQuerySubjectJoinOperation();
		var featureList = result.getFeatureList(factory);
		MoserObject.fromJSONHelper(result, featureList, json, factory);
		return result;
	}

	/**
	 * Adds the <code>item</code> to the collection at the given position and fires a notification to listeners.
	 */
	addQueryRefAt(position, item) {
		this._addAtAndNotify(this.getQueryRef(), position, item, 174, false, false);
	}

	/**
	 * Adds the <code>item</code> to the end of the collection and fires a notification to listeners.
	 */
	addQueryRef(item) {
		this.addQueryRefAt(this.getQueryRef().length, item);
	}

	/**
	 * Removes the item at <code>position</code> from the collection and fires a notification to listeners.
	 */
	removeQueryRefAt(position) {
		this._removeAtAndNotify(this.getQueryRef(), position, 174, false);
	}

	/**
	 * Removes the <code>item</code> from the collection and fires a notification to listeners.
	 */
	removeQueryRef(item) {
		var i = this.getQueryRef().indexOf(item);
		if (i >= 0) {
			this.removeQueryRefAt(i);
		}
	}

	/**
	 * Adds the <code>item</code> to the collection at the given position and fires a notification to listeners.
	 */
	addRelationshipAt(position, item) {
		this._addAtAndNotify(this.getRelationship(), position, item, 62, true, true);
	}

	/**
	 * Adds the <code>item</code> to the end of the collection and fires a notification to listeners.
	 */
	addRelationship(item) {
		this.addRelationshipAt(this.getRelationship().length, item);
	}

	/**
	 * Removes the item at <code>position</code> from the collection and fires a notification to listeners.
	 */
	removeRelationshipAt(position) {
		this._removeAtAndNotify(this.getRelationship(), position, 62, true);
	}

	/**
	 * Removes the <code>item</code> from the collection and fires a notification to listeners.
	 */
	removeRelationship(item) {
		var i = this.getRelationship().indexOf(item);
		if (i >= 0) {
			this.removeRelationshipAt(i);
		}
	}

	/**
	 * Retrieves the type of this object
	 * @return {String} the object type in a <code>String</code>
	 */
	getObjectType() {
		return "JoinOperation";
	}

	/**
	 * Get a list of FeatureObjects
	 * @return {Array} A list of FeatureObjects
	 */
	getFeatureList(factory) {
		var featureList = [];
		featureList.push(this.createFeature(true, false, false, 174, "queryRef", null));
		var clazz;
		if (factory) {
			clazz = factory.createRelationship().getClass();
		}
		featureList.push(this.createFeature(true, false, true, 62, "relationship", clazz));
		Array.prototype.push.apply(featureList, super.getFeatureList(factory));
		return featureList;
	}

	/**
	 * Set the value of a specific feature.
	 * @param {BaseMoserObject} value the value to set
	 * @param {int} featureID the feature id of the attribute to be set
	 */
	set(featureID, value) {
		switch (featureID) {
		default:
			throw new Error((("The feature " + featureID) + " is not valid."));
		}
	}

	/**
	 * Set the value of a specific feature.
	 * @param {BaseMoserObject} value the value to set the value to set
	 * @param {int} featureID the feature id of the attribute to be set the feature id of the attribute to be set
	 */
	_setList(featureID, value) {
		switch (featureID) {
		case 174:
			this.queryRef = (value);
			break;
		case 62:
			this.relationship = (value);
			break;
		default:
			throw new Error((("The feature " + featureID) + " is not valid."));
		}
	}

	/**
	 * Get the value of a specific feature.
	 * @param {int} featureID the feature id of the attribute to get
	 */
	get(featureID) {
		switch (featureID) {
		case 174:
			return this.getQueryRef();
		case 62:
			return this.getRelationship();
		default:
			throw new Error((("The feature " + featureID) + " is not valid."));
		}
	}

	/**
	 * Get the value of a specific feature.
	 * @param {int} featureID the feature id of the attribute to get
	 */
	basicGet(featureID) {
		switch (featureID) {
		case 174:
			return this.basicGetQueryRef();
		case 62:
			return this.basicGetRelationship();
		default:
			throw new Error((("The feature " + featureID) + " is not valid."));
		}
	}

	/**
	 * Add the value of a specific feature at a specific position
	 * @param {int} position the array position of the item to be added
	 * @param {BaseMoserObject} value the value to add
	 * @param {int} featureID the feature id of the attribute to be added
	 */
	addAt(featureID, position, value) {
		switch (featureID) {
		case 174:
			this.addQueryRefAt(position, (value));
			break;
		case 62:
			this.addRelationshipAt(position, (value));
			break;
		default:
			throw new Error((("The feature " + featureID) + " is not valid."));
		}
	}

	/**
	 * Add the value to the end of a specific collection feature
	 * @param {BaseMoserObject} value the value to add
	 * @param {int} featureID the feature id of the attribute to be added
	 */
	add(featureID, value) {
		switch (featureID) {
		case 174:
			this.addQueryRef((value));
			break;
		case 62:
			this.addRelationship((value));
			break;
		default:
			throw new Error((("The feature " + featureID) + " is not valid."));
		}
	}

	/**
	 * Remove the value of a specific feature by index.
	 * @param {int} position the array position of the item to be removed
	 * @param {int} featureID the feature id of the attribute to be removed
	 */
	removeAt(featureID, position) {
		switch (featureID) {
		case 174:
			this.removeQueryRefAt(position);
			break;
		case 62:
			this.removeRelationshipAt(position);
			break;
		default:
			throw new Error((("The feature " + featureID) + " is not valid."));
		}
	}

	/**
	 * Remove the value from specific feature.
	 * @param {BaseMoserObject} item the item to be removed
	 * @param {int} featureID the feature id of the attribute to be removed
	 */
	remove(featureID, item) {
		switch (featureID) {
		case 174:
			this.removeQueryRef((item));
			break;
		case 62:
			this.removeRelationship((item));
			break;
		default:
			throw new Error((("The feature " + featureID) + " is not valid."));
		}
	}
}
/**
 * <p>Java class for anonymous complex type. <p>The following schema fragment specifies the expected content contained within this class. <pre> &lt;complexType&gt; &lt;complexContent&gt; &lt;restriction base="{http://www.w3.org/2001/XMLSchema}anyType"&gt; &lt;sequence&gt; &lt;element name="queryRef" type="{http://www.w3.org/2001/XMLSchema}string" maxOccurs="unbounded"/&gt; &lt;element name="setOperation" type="{}setOperation"/&gt; &lt;element name="duplicates" type="{}setOperationDuplicates"/&gt; &lt;/sequence&gt; &lt;/restriction&gt; &lt;/complexContent&gt; &lt;/complexType&gt; </pre>
 */
QuerySubject.QueryOperation = class extends MoserObject{

	queryRef = null;

	setOperation = null;

	duplicates = null;



	/**
	 * Gets the value of the queryRef property. <p> This accessor method returns a reference to the live list, not a snapshot. Therefore any modification you make to the returned list will be present inside the JAXB object. This is why there is not a <CODE>set</CODE> method for the queryRef property. <p> For example, to add a new item, do as follows: <pre> getQueryRef().add(newItem); </pre> <p> Objects of the following type(s) are allowed in the list {@link String}
	 */
	getQueryRef() {
		if (!this.queryRef) {
			this.queryRef = [];
		}
		return this.queryRef;
	}

	/**
	 * Gets the value of the setOperation property.
	 * @return {SetOperation} possible object is {@link SetOperation}
	 */
	getSetOperation() {
		return this.setOperation;
	}

	/**
	 * Sets the value of the setOperation property.
	 * @param {SetOperation} value allowed object is {@link SetOperation}
	 */
	setSetOperation(value) {
		var oldValue = this.setOperation;
		this.setOperation = value;
		this._setAndNotify(175, oldValue, value, false, false);
	}

	/**
	 * Gets the value of the duplicates property.
	 * @return {SetOperationDuplicates} possible object is {@link SetOperationDuplicates}
	 */
	getDuplicates() {
		return this.duplicates;
	}

	/**
	 * Sets the value of the duplicates property.
	 * @param {SetOperationDuplicates} value allowed object is {@link SetOperationDuplicates}
	 */
	setDuplicates(value) {
		var oldValue = this.duplicates;
		this.duplicates = value;
		this._setAndNotify(176, oldValue, value, false, false);
	}

	/**
	 * Gets the value of the <code>queryRef</code> property without initializing the property to an empty list if it is unset.
	 * @return {Array} the list of <code>String</code> elements, or <code>null</code> if not set
	 */
	basicGetQueryRef() {
		return this.queryRef;
	}

	/**
	 * Creates a new instance of <code>QueryOperation</code> object from JSON data.
	 * @param {ObjectFactory} factory <code>ObjectFactory</> object for object creation.
	 * @param {Object} json JSON data to be used to create the <code> QueryOperation</code> object from.
	 * @return {QueryOperation} an object of type <code>QueryOperation</code>
	 */
	static fromJSON(json, factory) {
		var result = factory.createQuerySubjectQueryOperation();
		var featureList = result.getFeatureList(factory);
		MoserObject.fromJSONHelper(result, featureList, json, factory);
		return result;
	}

	/**
	 * Adds the <code>item</code> to the collection at the given position and fires a notification to listeners.
	 */
	addQueryRefAt(position, item) {
		this._addAtAndNotify(this.getQueryRef(), position, item, 174, false, false);
	}

	/**
	 * Adds the <code>item</code> to the end of the collection and fires a notification to listeners.
	 */
	addQueryRef(item) {
		this.addQueryRefAt(this.getQueryRef().length, item);
	}

	/**
	 * Removes the item at <code>position</code> from the collection and fires a notification to listeners.
	 */
	removeQueryRefAt(position) {
		this._removeAtAndNotify(this.getQueryRef(), position, 174, false);
	}

	/**
	 * Removes the <code>item</code> from the collection and fires a notification to listeners.
	 */
	removeQueryRef(item) {
		var i = this.getQueryRef().indexOf(item);
		if (i >= 0) {
			this.removeQueryRefAt(i);
		}
	}

	/**
	 * Retrieves the type of this object
	 * @return {String} the object type in a <code>String</code>
	 */
	getObjectType() {
		return "QueryOperation";
	}

	/**
	 * Get a list of FeatureObjects
	 * @return {Array} A list of FeatureObjects
	 */
	getFeatureList(factory) {
		var featureList = [];
		featureList.push(this.createFeature(true, false, false, 174, "queryRef", null));
		featureList.push(this.createFeature(false, true, false, 175, "setOperation", SetOperation));
		featureList.push(this.createFeature(false, true, false, 176, "duplicates", SetOperationDuplicates));
		Array.prototype.push.apply(featureList, super.getFeatureList(factory));
		return featureList;
	}

	/**
	 * Set the value of a specific feature.
	 * @param {BaseMoserObject} value the value to set
	 * @param {int} featureID the feature id of the attribute to be set
	 */
	set(featureID, value) {
		switch (featureID) {
		case 175:
			this.setSetOperation((value));
			break;
		case 176:
			this.setDuplicates((value));
			break;
		default:
			throw new Error((("The feature " + featureID) + " is not valid."));
		}
	}

	/**
	 * Set the value of a specific feature.
	 * @param {BaseMoserObject} value the value to set the value to set
	 * @param {int} featureID the feature id of the attribute to be set the feature id of the attribute to be set
	 */
	_setList(featureID, value) {
		switch (featureID) {
		case 174:
			this.queryRef = (value);
			break;
		default:
			throw new Error((("The feature " + featureID) + " is not valid."));
		}
	}

	/**
	 * Get the value of a specific feature.
	 * @param {int} featureID the feature id of the attribute to get
	 */
	get(featureID) {
		switch (featureID) {
		case 174:
			return this.getQueryRef();
		case 175:
			return this.getSetOperation();
		case 176:
			return this.getDuplicates();
		default:
			throw new Error((("The feature " + featureID) + " is not valid."));
		}
	}

	/**
	 * Get the value of a specific feature.
	 * @param {int} featureID the feature id of the attribute to get
	 */
	basicGet(featureID) {
		switch (featureID) {
		case 174:
			return this.basicGetQueryRef();
		case 175:
			return this.getSetOperation();
		case 176:
			return this.getDuplicates();
		default:
			throw new Error((("The feature " + featureID) + " is not valid."));
		}
	}

	/**
	 * Add the value of a specific feature at a specific position
	 * @param {int} position the array position of the item to be added
	 * @param {BaseMoserObject} value the value to add
	 * @param {int} featureID the feature id of the attribute to be added
	 */
	addAt(featureID, position, value) {
		switch (featureID) {
		case 174:
			this.addQueryRefAt(position, (value));
			break;
		default:
			throw new Error((("The feature " + featureID) + " is not valid."));
		}
	}

	/**
	 * Add the value to the end of a specific collection feature
	 * @param {BaseMoserObject} value the value to add
	 * @param {int} featureID the feature id of the attribute to be added
	 */
	add(featureID, value) {
		switch (featureID) {
		case 174:
			this.addQueryRef((value));
			break;
		default:
			throw new Error((("The feature " + featureID) + " is not valid."));
		}
	}

	/**
	 * Remove the value of a specific feature by index.
	 * @param {int} position the array position of the item to be removed
	 * @param {int} featureID the feature id of the attribute to be removed
	 */
	removeAt(featureID, position) {
		switch (featureID) {
		case 174:
			this.removeQueryRefAt(position);
			break;
		default:
			throw new Error((("The feature " + featureID) + " is not valid."));
		}
	}

	/**
	 * Remove the value from specific feature.
	 * @param {BaseMoserObject} item the item to be removed
	 * @param {int} featureID the feature id of the attribute to be removed
	 */
	remove(featureID, item) {
		switch (featureID) {
		case 174:
			this.removeQueryRef((item));
			break;
		default:
			throw new Error((("The feature " + featureID) + " is not valid."));
		}
	}
}
/**
 * <p>Java class for anonymous complex type. <p>The following schema fragment specifies the expected content contained within this class. <pre> &lt;complexType&gt; &lt;complexContent&gt; &lt;restriction base="{http://www.w3.org/2001/XMLSchema}anyType"&gt; &lt;sequence&gt; &lt;element name="perspective" type="{}perspectiveType" minOccurs="0"/&gt; &lt;element name="theDate" type="{http://www.w3.org/2001/XMLSchema}string" minOccurs="0"/&gt; &lt;/sequence&gt; &lt;/restriction&gt; &lt;/complexContent&gt; &lt;/complexType&gt; </pre>
 */
QuerySubject.TimeAnchor = class extends MoserObject{

	perspective = null;

	theDate = null;



	/**
	 * Gets the value of the perspective property.
	 * @return {PerspectiveType} possible object is {@link PerspectiveType}
	 */
	getPerspective() {
		return this.perspective;
	}

	/**
	 * Sets the value of the perspective property.
	 * @param {PerspectiveType} value allowed object is {@link PerspectiveType}
	 */
	setPerspective(value) {
		var oldValue = this.perspective;
		this.perspective = value;
		this._setAndNotify(179, oldValue, value, false, false);
	}

	/**
	 * Gets the value of the theDate property.
	 * @return {String} possible object is {@link String}
	 */
	getTheDate() {
		return this.theDate;
	}

	/**
	 * Sets the value of the theDate property.
	 * @param {String} value allowed object is {@link String}
	 */
	setTheDate(value) {
		var oldValue = this.theDate;
		this.theDate = value;
		this._setAndNotify(180, oldValue, value, false, false);
	}

	/**
	 * Creates a new instance of <code>TimeAnchor</code> object from JSON data.
	 * @param {ObjectFactory} factory <code>ObjectFactory</> object for object creation.
	 * @param {Object} json JSON data to be used to create the <code> TimeAnchor</code> object from.
	 * @return {TimeAnchor} an object of type <code>TimeAnchor</code>
	 */
	static fromJSON(json, factory) {
		var result = factory.createQuerySubjectTimeAnchor();
		var featureList = result.getFeatureList(factory);
		MoserObject.fromJSONHelper(result, featureList, json, factory);
		return result;
	}

	/**
	 * Retrieves the type of this object
	 * @return {String} the object type in a <code>String</code>
	 */
	getObjectType() {
		return "TimeAnchor";
	}

	/**
	 * Get a list of FeatureObjects
	 * @return {Array} A list of FeatureObjects
	 */
	getFeatureList(factory) {
		var featureList = [];
		featureList.push(this.createFeature(false, true, false, 179, "perspective", PerspectiveType));
		featureList.push(this.createFeature(false, false, false, 180, "theDate", null));
		Array.prototype.push.apply(featureList, super.getFeatureList(factory));
		return featureList;
	}

	/**
	 * Set the value of a specific feature.
	 * @param {BaseMoserObject} value the value to set
	 * @param {int} featureID the feature id of the attribute to be set
	 */
	set(featureID, value) {
		switch (featureID) {
		case 179:
			this.setPerspective((value));
			break;
		case 180:
			this.setTheDate((value));
			break;
		default:
			throw new Error((("The feature " + featureID) + " is not valid."));
		}
	}

	/**
	 * Get the value of a specific feature.
	 * @param {int} featureID the feature id of the attribute to get
	 */
	get(featureID) {
		switch (featureID) {
		case 179:
			return this.getPerspective();
		case 180:
			return this.getTheDate();
		default:
			throw new Error((("The feature " + featureID) + " is not valid."));
		}
	}

	/**
	 * Get the value of a specific feature.
	 * @param {int} featureID the feature id of the attribute to get
	 */
	basicGet(featureID) {
		switch (featureID) {
		case 179:
			return this.getPerspective();
		case 180:
			return this.getTheDate();
		default:
			throw new Error((("The feature " + featureID) + " is not valid."));
		}
	}
}
/**
 * <p>Java class for anonymous complex type. <p>The following schema fragment specifies the expected content contained within this class. <pre> &lt;complexType&gt; &lt;complexContent&gt; &lt;restriction base="{http://www.w3.org/2001/XMLSchema}anyType"&gt; &lt;sequence&gt; &lt;element name="periodName" type="{http://www.w3.org/2001/XMLSchema}string" minOccurs="0"/&gt; &lt;element name="numPeriods" type="{http://www.w3.org/2001/XMLSchema}string" maxOccurs="unbounded"/&gt; &lt;/sequence&gt; &lt;/restriction&gt; &lt;/complexContent&gt; &lt;/complexType&gt; </pre>
 */
QuerySubject.TimeGrain = class extends MoserObject{

	periodName = null;

	numPeriods = null;



	/**
	 * Gets the value of the periodName property.
	 * @return {String} possible object is {@link String}
	 */
	getPeriodName() {
		return this.periodName;
	}

	/**
	 * Sets the value of the periodName property.
	 * @param {String} value allowed object is {@link String}
	 */
	setPeriodName(value) {
		var oldValue = this.periodName;
		this.periodName = value;
		this._setAndNotify(177, oldValue, value, false, false);
	}

	/**
	 * Gets the value of the numPeriods property. <p> This accessor method returns a reference to the live list, not a snapshot. Therefore any modification you make to the returned list will be present inside the JAXB object. This is why there is not a <CODE>set</CODE> method for the numPeriods property. <p> For example, to add a new item, do as follows: <pre> getNumPeriods().add(newItem); </pre> <p> Objects of the following type(s) are allowed in the list {@link String}
	 */
	getNumPeriods() {
		if (!this.numPeriods) {
			this.numPeriods = [];
		}
		return this.numPeriods;
	}

	/**
	 * Gets the value of the <code>numPeriods</code> property without initializing the property to an empty list if it is unset.
	 * @return {Array} the list of <code>String</code> elements, or <code>null</code> if not set
	 */
	basicGetNumPeriods() {
		return this.numPeriods;
	}

	/**
	 * Creates a new instance of <code>TimeGrain</code> object from JSON data.
	 * @param {ObjectFactory} factory <code>ObjectFactory</> object for object creation.
	 * @param {Object} json JSON data to be used to create the <code> TimeGrain</code> object from.
	 * @return {TimeGrain} an object of type <code>TimeGrain</code>
	 */
	static fromJSON(json, factory) {
		var result = factory.createQuerySubjectTimeGrain();
		var featureList = result.getFeatureList(factory);
		MoserObject.fromJSONHelper(result, featureList, json, factory);
		return result;
	}

	/**
	 * Adds the <code>item</code> to the collection at the given position and fires a notification to listeners.
	 */
	addNumPeriodsAt(position, item) {
		this._addAtAndNotify(this.getNumPeriods(), position, item, 178, false, false);
	}

	/**
	 * Adds the <code>item</code> to the end of the collection and fires a notification to listeners.
	 */
	addNumPeriods(item) {
		this.addNumPeriodsAt(this.getNumPeriods().length, item);
	}

	/**
	 * Removes the item at <code>position</code> from the collection and fires a notification to listeners.
	 */
	removeNumPeriodsAt(position) {
		this._removeAtAndNotify(this.getNumPeriods(), position, 178, false);
	}

	/**
	 * Removes the <code>item</code> from the collection and fires a notification to listeners.
	 */
	removeNumPeriods(item) {
		var i = this.getNumPeriods().indexOf(item);
		if (i >= 0) {
			this.removeNumPeriodsAt(i);
		}
	}

	/**
	 * Retrieves the type of this object
	 * @return {String} the object type in a <code>String</code>
	 */
	getObjectType() {
		return "TimeGrain";
	}

	/**
	 * Get a list of FeatureObjects
	 * @return {Array} A list of FeatureObjects
	 */
	getFeatureList(factory) {
		var featureList = [];
		featureList.push(this.createFeature(false, false, false, 177, "periodName", null));
		featureList.push(this.createFeature(true, false, false, 178, "numPeriods", null));
		Array.prototype.push.apply(featureList, super.getFeatureList(factory));
		return featureList;
	}

	/**
	 * Set the value of a specific feature.
	 * @param {BaseMoserObject} value the value to set
	 * @param {int} featureID the feature id of the attribute to be set
	 */
	set(featureID, value) {
		switch (featureID) {
		case 177:
			this.setPeriodName((value));
			break;
		default:
			throw new Error((("The feature " + featureID) + " is not valid."));
		}
	}

	/**
	 * Set the value of a specific feature.
	 * @param {BaseMoserObject} value the value to set the value to set
	 * @param {int} featureID the feature id of the attribute to be set the feature id of the attribute to be set
	 */
	_setList(featureID, value) {
		switch (featureID) {
		case 178:
			this.numPeriods = (value);
			break;
		default:
			throw new Error((("The feature " + featureID) + " is not valid."));
		}
	}

	/**
	 * Get the value of a specific feature.
	 * @param {int} featureID the feature id of the attribute to get
	 */
	get(featureID) {
		switch (featureID) {
		case 177:
			return this.getPeriodName();
		case 178:
			return this.getNumPeriods();
		default:
			throw new Error((("The feature " + featureID) + " is not valid."));
		}
	}

	/**
	 * Get the value of a specific feature.
	 * @param {int} featureID the feature id of the attribute to get
	 */
	basicGet(featureID) {
		switch (featureID) {
		case 177:
			return this.getPeriodName();
		case 178:
			return this.basicGetNumPeriods();
		default:
			throw new Error((("The feature " + featureID) + " is not valid."));
		}
	}

	/**
	 * Add the value of a specific feature at a specific position
	 * @param {int} position the array position of the item to be added
	 * @param {BaseMoserObject} value the value to add
	 * @param {int} featureID the feature id of the attribute to be added
	 */
	addAt(featureID, position, value) {
		switch (featureID) {
		case 178:
			this.addNumPeriodsAt(position, (value));
			break;
		default:
			throw new Error((("The feature " + featureID) + " is not valid."));
		}
	}

	/**
	 * Add the value to the end of a specific collection feature
	 * @param {BaseMoserObject} value the value to add
	 * @param {int} featureID the feature id of the attribute to be added
	 */
	add(featureID, value) {
		switch (featureID) {
		case 178:
			this.addNumPeriods((value));
			break;
		default:
			throw new Error((("The feature " + featureID) + " is not valid."));
		}
	}

	/**
	 * Remove the value of a specific feature by index.
	 * @param {int} position the array position of the item to be removed
	 * @param {int} featureID the feature id of the attribute to be removed
	 */
	removeAt(featureID, position) {
		switch (featureID) {
		case 178:
			this.removeNumPeriodsAt(position);
			break;
		default:
			throw new Error((("The feature " + featureID) + " is not valid."));
		}
	}

	/**
	 * Remove the value from specific feature.
	 * @param {BaseMoserObject} item the item to be removed
	 * @param {int} featureID the feature id of the attribute to be removed
	 */
	remove(featureID, item) {
		switch (featureID) {
		case 178:
			this.removeNumPeriods((item));
			break;
		default:
			throw new Error((("The feature " + featureID) + " is not valid."));
		}
	}
}


// WEBPACK FOOTER //
// ./src/generated/QuerySubject.js